<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">HLR Reset</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container class="pt-5 w-50" style="min-width: max-content; max-width: 600px;">
			<b-card>
				<b-form>
					<b-row>
						<b-col xl="4" lg="4" sm="6">
							<p class="mt-3">
								<span class="h3">IMSI</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="6">
							<b-form-group label-for="input-1">
								<b-form-input type="number" placeholder="Full IMSI Number" :state="imsiState" v-model="imsi"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="4" lg="4" sm="6">
							<p class="mt-3">
								<span class="h3">HLR GT</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="6">
							<b-form-group label-for="input-1">
								<b-form-input id="input-1" type="number" placeholder="HLR GT Number" :state="hlrGtState" v-model="hlrGt"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="4" lg="4" sm="6">
							<p class="mt-3">
								<span class="h3">VLR GT List</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="6">
							<b-form-group label-for="input-1">
								<b-form-textarea
									id="vlr-gt-list"
									v-model="vlrGtList"
									size="sm"
									placeholder="Values must be separated by a comma"
									:state="sgsnVlrGtListState"
								></b-form-textarea>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="4" lg="4" sm="6">
							<p class="mt-3">
								<span class="h3">SGNS GT List</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="6">
							<b-form-group label-for="input-1">
								<b-form-textarea
									id="vlr-gt-list"
									v-model="sgsnGtList"
									size="sm"
									placeholder="Values must be separated by a comma"
									:state="sgsnVlrGtListState"
								></b-form-textarea>
							</b-form-group>
						</b-col>
					</b-row>

					<hr />
					<div class="mt-3 d-flex justify-content-between">
						<base-button type="danger" title="Clear" v-on:click="reset()"> Clear </base-button>
						<base-button
							type="primary"
							title="Search"
							v-on:click="submitReset($event)"
							:disabled="submitDisabled"
							:loading="submitLoading"
						>
							Submit
						</base-button>
					</div>
				</b-form>
			</b-card>
		</b-container>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import troubleshootingService from "../../../common/api-services/troubleshooting-service";
import initService from "../../../common/api-services/init-service";

export default {
	name: "hlr-reset",
	components: {
		RouteBreadCrumb,
	},
	mounted() {
		document.title = "Troubleshooting - HLR Reset";
		this.noAccess =
			!initService.getUserRoles().includes("Administrator") &&
			!initService.getUserRoles().includes("CARRIER_ADMIN") &&
			!initService.getUserRoles().includes("PORTAL_ADMIN ");

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/home");
		}
	},
	data() {
		return {
			imsi: "",
			hlrGt: "",
			vlrGtList: "",
			sgsnGtList: "",
			submitLoading: false,
		};
	},
	computed: {
		submitDisabled() {
			return !this.imsiState || !this.hlrGtState || !this.sgsnVlrGtListState;
		},
		imsiState() {
			return this.imsi.length === 15;
		},
		hlrGtState() {
			return this.hlrGt.length > 0;
		},
		sgsnVlrGtListState() {
			return this.vlrGtList.length > 0 || this.sgsnGtList.length > 0;
		},
		sgsnGtListState() {
			return this.sgsnGtList.length > 0;
		},
	},
	methods: {
		submitReset(event) {
			event.preventDefault();
			this.submitLoading = true;
			troubleshootingService
				.sendHlrReset(this.imsi, this.hlrGt, this.vlrGtList, this.sgsnGtList)
				.then(response => {
					if (response.message.hasOwnProperty("Error")) {
						this.$toast.error(response.message.Error);
						return;
					}
					this.reset();
					this.$toast.success(response.message[0]);
				})
				.catch(error => {
					console.log(error);
					this.$toast.error(error);
				});
			this.submitLoading = false;
		},
		reset() {
			this.imsi = "";
			this.hlrGt = "";
			this.vlrGtList = "";
			this.sgsnGtList = "";
		},
	},
};
</script>
